/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Rag_Knowledge_Assistants_Access_Desc6Inputs */

const en_svc_rag_knowledge_assistants_access_desc6 = /** @type {(inputs: Svc_Rag_Knowledge_Assistants_Access_Desc6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Users only see what they are allowed to see, enforced at retrieval time.`)
};

const ar_svc_rag_knowledge_assistants_access_desc6 = /** @type {(inputs: Svc_Rag_Knowledge_Assistants_Access_Desc6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`لا يرى المستخدمون إلا ما يسمح لهم به، ويطبق ذلك وقت الاسترجاع.`)
};

const bn_svc_rag_knowledge_assistants_access_desc6 = /** @type {(inputs: Svc_Rag_Knowledge_Assistants_Access_Desc6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ব্যবহারকারীরা শুধু সেটাই দেখে যার অনুমতি আছে, রিট্রিভালের সময় প্রয়োগ হয়।`)
};

const de_svc_rag_knowledge_assistants_access_desc6 = /** @type {(inputs: Svc_Rag_Knowledge_Assistants_Access_Desc6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nutzer sehen nur, was sie sehen dürfen, durchgesetzt zum Retrieval-Zeitpunkt.`)
};

const es_svc_rag_knowledge_assistants_access_desc6 = /** @type {(inputs: Svc_Rag_Knowledge_Assistants_Access_Desc6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cada usuario solo ve lo que tiene permitido ver, aplicado en la recuperación.`)
};

const fr_svc_rag_knowledge_assistants_access_desc6 = /** @type {(inputs: Svc_Rag_Knowledge_Assistants_Access_Desc6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Les utilisateurs ne voient que ce qu'ils ont le droit de voir, appliqué au moment de la récupération.`)
};

const pt_svc_rag_knowledge_assistants_access_desc6 = /** @type {(inputs: Svc_Rag_Knowledge_Assistants_Access_Desc6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cada utilizador só vê o que tem permissão para ver, aplicado na recuperação.`)
};

const zh_svc_rag_knowledge_assistants_access_desc6 = /** @type {(inputs: Svc_Rag_Knowledge_Assistants_Access_Desc6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`用户只能看到被允许的内容，在检索时强制执行。`)
};

const tr_svc_rag_knowledge_assistants_access_desc6 = /** @type {(inputs: Svc_Rag_Knowledge_Assistants_Access_Desc6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kullanıcılar yalnızca görmeye yetkili olduklarını görür, getirme anında uygulanır.`)
};

const ru_svc_rag_knowledge_assistants_access_desc6 = /** @type {(inputs: Svc_Rag_Knowledge_Assistants_Access_Desc6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Пользователи видят только то, что им разрешено, применяется в момент поиска.`)
};

const pl_svc_rag_knowledge_assistants_access_desc6 = /** @type {(inputs: Svc_Rag_Knowledge_Assistants_Access_Desc6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Użytkownicy widzą tylko to, co im wolno, egzekwowane w momencie wyszukiwania.`)
};

/**
* | output |
* | --- |
* | "Users only see what they are allowed to see, enforced at retrieval time." |
*
* @param {Svc_Rag_Knowledge_Assistants_Access_Desc6Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_rag_knowledge_assistants_access_desc6 = /** @type {((inputs?: Svc_Rag_Knowledge_Assistants_Access_Desc6Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Rag_Knowledge_Assistants_Access_Desc6Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_rag_knowledge_assistants_access_desc6(inputs)
	if (locale === "bn") return bn_svc_rag_knowledge_assistants_access_desc6(inputs)
	if (locale === "de") return de_svc_rag_knowledge_assistants_access_desc6(inputs)
	if (locale === "es") return es_svc_rag_knowledge_assistants_access_desc6(inputs)
	if (locale === "fr") return fr_svc_rag_knowledge_assistants_access_desc6(inputs)
	if (locale === "pt") return pt_svc_rag_knowledge_assistants_access_desc6(inputs)
	if (locale === "zh") return zh_svc_rag_knowledge_assistants_access_desc6(inputs)
	if (locale === "tr") return tr_svc_rag_knowledge_assistants_access_desc6(inputs)
	if (locale === "ru") return ru_svc_rag_knowledge_assistants_access_desc6(inputs)
	if (locale === "pl") return pl_svc_rag_knowledge_assistants_access_desc6(inputs)
	return en_svc_rag_knowledge_assistants_access_desc6(inputs)
});
export { svc_rag_knowledge_assistants_access_desc6 as "svc_rag-knowledge-assistants_ACCESS_desc" }